<template>
    <div class="page">
        <div class="top">
            <div class="top-content">
                <div class="top-content-top">
                    <div class="top-content-top-items">{{ dataForm.packageName ? dataForm.packageName : dataForm.name }}
                    </div>
                    <div class="time">
                        <van-icon name="warning" color="#DCDCDC" size="16" />
                        关于预充值卡
                    </div>
                </div>
                <div class="top-content-middle">
                    <div class="top-content-top-items">套餐有效期：</div>
                    <div class="time">{{ dataForm.startTime }} 至 {{ dataForm.endTime }}</div>
                </div>
                <div class="top-content-middle">
                    <div class="top-content-top-items">套餐价格：</div>
                    <div class="time">{{ ((dataForm.salePriceRmb ? dataForm.salePriceRmb : dataForm.salePrice /  100) * 1).toFixed(2) }}元</div>
                </div>
            </div>
        </div>
        <div class="preferential" @click="selectCoupon">
            <div class="roll">惠</div>
            <div class="roll-up">活动余额</div>
            <div class="roll-proce">- {{ dataForm.price }} 元</div>
        </div>
        <div class="section">
            <div class="page-service">
                <van-checkbox-group v-model="result">
                    <van-cell-group>
                        <van-cell clickable title="续费加油包" @click="toggle()" class="v-checkbox">
                            <template #right-icon>
                                <van-checkbox name="1" ref="checkboxes" />
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
            </div>
            <div class="page-payment">
                <div class="name">支付方式</div>
                <van-radio-group v-model="radio">
                    <van-cell-group>
                        <template v-for="(item, index) in payTypeList">
                            <van-cell
                                v-if="item !== 'aliCollectConfig' && item !== 'yeCollectConfig' && item !== 'jdCollectConfig'"
                                title="微信支付" clickable class="wx-icon" :key="index">
                                <template #right-icon>
                                    <van-radio :name="item" />
                                </template>
                            </van-cell>
                            <van-cell title="支付宝" v-if="item === 'aliCollectConfig'" clickable class="ali-icon"
                                :key="index">
                                <template #right-icon>
                                    <van-radio name="aliCollectConfig" />
                                </template>
                            </van-cell>
                            <van-cell title="账户余额支付" v-if="item === 'yeCollectConfig'" clickable class="yue-icon"
                                :key="index">
                                <template #right-icon>
                                    <van-radio name="yeCollectConfig" />
                                </template>
                            </van-cell>
                        </template>
                    </van-cell-group>
                </van-radio-group>
            </div>
        </div>
        <div class="footer">
            <div class="agreement">
                <van-checkbox v-model="checked">我已阅读</van-checkbox><span @click="aaaaa">《自动续订服务协议》</span>
            </div>
            <div class="payment">
                <div class="payment-items">
                    <div class="">需支付：</div>
                    <div class="price">￥<span>
                            {{ (dataForm.salePriceRmb* 1 ? dataForm.salePriceRmb* 1 : dataForm.salePrice / 100) -
                                (dataForm.price * 1) > 0 ? ((dataForm.salePriceRmb* 1 ? dataForm.salePriceRmb* 1 : dataForm.salePrice /
                                    100) - (dataForm.price * 1)) .toFixed(2) : 0 }}
                        </span></div>
                    <div class="price-small">{{ ((dataForm.salePriceRmb ? dataForm.salePriceRmb : dataForm.salePrice /  100) * 1).toFixed(2) }}</div>
                </div>
                <div class="payment-btn">
                    <van-button type="primary" block round color="#397EF5" @click="sumbit">去支付</van-button>
                </div>
            </div>
        </div>
        <div v-html="payUrl"></div>
        <div class="shareit" v-if="is_WeChat">
            <img class="arrow" src="@/assets/img/arrowhead.png" />
            <div class="follow">支付宝支付请右上角点击 在游览器打开 进行支付,<br />支付成功后 请重新扫码登录进行激活操作<br /></div>
        </div>
    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import { wxRequest } from "@/api/user.js";
export default {
    data() {
        return {
            checked: true,
            result: [],
            radio: 'yeCollectConfig',
            payUrl: '',
            is_WeChat: false,
            payTypeList: [],
            dataForm: {}
        }
    },
    created() {
        this.dataForm = JSON.parse(decodeURIComponent(this.$route.query.params))
        console.log(this.dataForm )
        wxRequest("/order/pay/chanle", { iccid: localStorage.getItem("iccid"),ali:localStorage.getItem("htmlType") }, "post").then((res) => {
            if (res.data.code === '200') {
                for (let i = 0; i < res.data.data.length; i++) {
                    this.payTypeList.push(res.data.data[i].typeKey);
                }
            }
        });
        // secondaryId,primaryId 如果选了优惠券，优惠券里面的id都在this.dataForm里面可以获取到
        this.selectIsAutoState()
    },
    methods: {
        toggle() {
            this.$refs.checkboxes.toggle();
            const param = {
                iccid: this.$store.state.iccid,
                isAuto: this.result.length === 0 ? 1 : 0
            }
            wxRequest('sysUser/account/update/isAuto/state/add', param, 'post').then(res => {
                if (res.data.code === '200') {
                    this.selectIsAutoState()
                } else {
                    Dialog.alert({ title: '修改提示', message: res.data.message })
                }
            })
        },
        selectCoupon() {
            this.$router.push({ path: '/new/coupon', query: { params: encodeURIComponent(JSON.stringify(this.dataForm)) } });
        },
        selectIsAutoState() {
            const param = {
                iccid: this.$store.state.iccid
            }
            wxRequest('sysUser/account/select/isAuto/state/add', param, 'post').then(res => {
                if (res.data.code === '200') {
                    this.result = res.data.data === 0 ? [] : ['1']
                }
            })
        },
        sumbit() {
            // if(!this.checked){
            //     Toast.fail('请勾选自动续订服务协议');
            //     return
            // }
            var params = {
                iccid: this.$store.state.iccid,
                soldPackageId: this.dataForm.id,
                isAdmin: this.dataForm.isAdmin,
                secondaryId: this.dataForm.secondaryId || '',
                primaryId: this.dataForm.primaryId || '',
                isNextMonth: 0,
                firstPkg: "1T",
                payType: 20
            }
            var postUrl = "order/pkgOrder/add";
            var payType = "20";
            if (this.radio === 'aliCollectConfig') {   //支付宝支付
                postUrl = "order/ali/pkgOrder/add";
                payType = "80";
            } else if (this.radio === 'hfCollectConfig') {  //汇丰支付
                postUrl = "order/hfPkgOrder/add";
                payType = "60";
            } else if (this.radio === 'miCollectConfig') {  //米花支付
                postUrl = "order/ali/pkgOrder/add/mihua";
                payType = "90";
            } else if (this.radio === 'dhCollectConfig') {  //斗洪支付 
                postUrl = "order/ali/pkgOrder/add/dh";
                payType = "90";
            } else if (this.radio === 'yeCollectConfig') {  //余额支付
                postUrl = "order/user/uniorder";
                payType = "10";
            } else if (this.radio === 'hlCollectConfig') {  //斗洪支付
                postUrl = "order/ali/pkgOrder/add/hl";
                payType = "90";
            }else if (this.radio === 'yyCollectConfig') {  //斗洪支付
                postUrl = "order/ali/pkgOrder/add/yy";
                payType = "92";
            }else if (this.radio === 'longCollectConfig') {  //斗洪支付
                postUrl = "order/ali/pkgOrder/add/long";
                payType = "93";
            }
            params.payType = payType;
            let formData = params;
            if (payType != 10) {
                formData = new FormData();
                Object.keys(params).forEach((key) => {
                    formData.append(key, params[key]);
                });
            }
            wxRequest(postUrl, formData, "post").then((res) => {
                if (res.data.code == 200) {
                    if (params.payType == 10) {
                        Toast.success('套餐购买成功！');
                        this.$router.push({ path: '/new/equipmentCard' });
                    } else if (params.payType == 92||params.payType == 93) {
                        //乐刷de
                        window.location.href = res.data.data;
                    } else if (params.payType == 20) {
                        //微信第三方
                        var param = res.data.data.param;
                        if (typeof WeixinJSBridge == "undefined") {
                            if (document.addEventListener) {
                                document.addEventListener("WeixinJSBridgeReady", this.onBridgeReady, false);
                            } else if (document.attachEvent) {
                                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                                document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
                            }
                        } else {
                            this.onBridgeReady(param);
                        }
                    } else if (params.payType == 90) {
                        //微信第三方
                        var param = res.data.data;
                        if (typeof WeixinJSBridge == "undefined") {
                            if (document.addEventListener) {
                                document.addEventListener("WeixinJSBridgeReady", this.onBridgeReady, false);
                            } else if (document.attachEvent) {
                                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                                document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
                            }
                        } else {
                            this.onBridgeReady(param);
                        }
                    } else if (params.payType == 60) {
                        //汇付天下
                        let datas = JSON.parse(res.data.data);
                        if (datas.status === "succeeded") {
                            let payment = datas;
                            AdaPay.doPay(payment, (res) => { Dialog.alert({ title: "提示", message: res.result_message }); });
                        }
                    } else if (params.payType == 80) {
                        var ua = window.navigator.userAgent.toLowerCase();
                        if (ua.match(/MicroMessenger/i) == "micromessenger") {
                            //进入引导页
                            this.is_WeChat = true;
                            var timer = setInterval(() => {
                                clearInterval(timer);
                                this.$router.push({
                                    path: "/new/serviceCenter",
                                    query: {
                                        row: encodeURIComponent(JSON.stringify(res.data.data)),
                                    },
                                });
                            }, 1000);
                        } else {
                            this.payUrl = res.data.data;
                            this.$nextTick(() => {
                                document.forms[0].submit();
                            });
                        }
                    }
                } else {
                    Dialog.alert({ message: res.data.message });
                }
            });
            //支付成功之后页面跳转
            //  this.$router.push({path: '/new/equipmentCard'}); 
        },
        onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    _this.$router.push({
                        path: "/new/equipmentCard",
                        query: {
                            iccid: _this.$store.state.iccid,
                        },
                    }).catch(() => { });
                }
            });
        },
        aaaaa() {
            Dialog.confirm({
                title: '关于加油包自动续费须知',
                width: '90%',
                showCancelButton: false,
                messageAlign: 'left',
                confirmButtonColor: '#ee0a24',
                message: `当卡的套餐流量使用完毕时，系统会自动用余额来购买加油包 避免卡因套餐用完停机。点击勾选后 此业务生效。`,
            }).then(() => {
                // on confirm
            }).catch(() => {
                // on cancel
            });
        },

    }
}
</script>
<style lang="less" scoped>
.page {
    // background: #F4F6FA;
    padding: 0 13px;
    background: linear-gradient(180deg, #3980F9 0%, rgba(244, 246, 250, 1) 240px);
    padding-bottom: 108px;
    height: calc(100% - 108px);
    position: relative;

    .top {
        height: 180px;
        padding-top: 20px;

        .top-content {
            height: 126px;
            width: calc(100% - 24px);
            background: #fff;
            border-radius: 10px;
            padding: 20px 12px;
            margin: 0 auto 10px;
        }

        .top-content-top {
            padding-bottom: 15px;
            display: flex;
            border-bottom: 1px solid #EDEDED;
            justify-content: space-between;
        }

        .top-content-top-items {
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #28292D;
            line-height: 22px;
        }

        .time {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #397EF5;
            line-height: 20px;
        }

        .top-content-middle {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
        }
    }

    .preferential {
        padding: 15px 35px 15px 11px;
        height: 22px;
        display: flex;
        width: calc(100% - 46px);
        border-radius: 10px;
        align-items: center;
        margin: 0 auto;
        background: #fff url('../../assets/new/newCopy/icon06.png') no-repeat 96% center;
        background-size: 9px 16px;

        .roll {
            width: 22px;
            height: 100%;
            border-radius: 4px;
            background: #FF894A;
            color: #fff;
            text-align: center;
            line-height: 22px;
        }

        .roll-up {
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #28292D;
            padding-left: 8px;
        }

        .roll-proce {
            color: #397EF5;
            font-size: 14px;
            width: calc(100% - 78px);
            text-align: right;
        }
    }

    .section {
        width: 100%;
        margin: 12px auto;

        .page-service {
            width: calc(100% - 22px);
            padding: 11px;
            border-radius: 10px;
            background: #E3EDFF;
        }

        .page-payment {
            border-radius: 10px;
            background: #fff;
            margin-top: 10px;
            width: calc(100% - 22px);
            padding: 11px;
            margin-bottom: 38px;

            .name {
                padding-bottom: 18px;
                font-size: 18px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #28292D;
                line-height: 25px;
            }
        }

        .wx-icon {
            background: url('./../../assets/new/newCopy/icon03.png') left center no-repeat;
            background-size: 26px 21px;
            padding-left: 35px;
        }

        .ali-icon {
            background: url('./../../assets/new/newCopy/icon02.png') left center no-repeat;
            background-size: 26px 26px;
            padding-left: 35px;
        }

        .yue-icon {
            background: url('./../../assets/new/newCopy/icon07.png') left center no-repeat;
            background-size: 26px 26px;
            padding-left: 35px;
        }

        .van-cell::after {
            border: none;
        }

        ::v-deep .van-cell-group::after {
            border: none;
        }

        .van-cell-group {
            background: none;
        }

        .v-checkbox {
            background: none;
            padding: 0;

            &:active {
                background: none;
            }

            .van-cell__title {
                span {
                    font-size: 16px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #28292D;
                    line-height: 22px;
                }
            }
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        background: #fff;
        width: 100%;
        padding: 19px 0 6px;
        left: 0;
        height: 83px;

        .agreement {
            padding-left: 13px;
            color: #28292D;
            display: flex;
            align-items: center;

            span {
                color: #397EF5;
            }
        }

        .payment {
            display: flex;
            margin-top: 19px;
            align-items: center;
            justify-content: space-between;

            .payment-items {
                display: flex;
                padding-left: 13px;
                align-items: center;

                .price {
                    color: #397EF5;
                    font-size: 14px;
                    font-family: HarmonyOS_Sans_SC_Bold;

                    span {
                        font-size: 24px;
                    }
                }

                .price-small {
                    padding-left: 6px;
                    color: #63666D;
                    font-size: 14px;
                    text-decoration: line-through;
                }
            }

            .payment-btn {
                margin-right: 12px;

                .van-button {
                    width: 156px;
                }
            }
        }
    }
}

.shareit {
    -webkit-user-select: none;
    position: fixed;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    text-align: center;
    top: 0;
    left: 0;
    z-index: 999;
}

.shareit img {
    max-width: 100%;
}

.arrow {
    width: 100px;
    height: 150px;
    position: absolute;
    right: 5%;
    top: 1%;
}

.follow {
    margin-right: 6px;
    margin-left: 30px;
    width: 90%;
    // height: 100rpx;
    line-height: 30px;
    // text-align: left;
    text-decoration: none;
    font-size: 18px;
    color: white;
    float: left;
    margin-top: 180px;
}</style>